import medicalCareDescriptionTypes from "constants/medicalCareDescriptionTypes";
import personResponsibleTypes from "constants/personResponsibleTypes";

export default {
  [medicalCareDescriptionTypes.DEATH]: personResponsibleTypes.DEATH,
  [medicalCareDescriptionTypes.INJURY]: personResponsibleTypes.INJURY,
  [medicalCareDescriptionTypes.SICK]: personResponsibleTypes.SICKNESS,
}
